<template>
  <div class="login-page">
    <div class="background-image">
      <img src="img/background.jpg" alt="" />
    </div>
    <div class="card-login">
      <div class="cclogo">
        <img src="img/call.png" width="100" alt="" />
      </div>
      <form @submit.prevent="Login">
        <div class="center">
          <base-input
            label="Username"
            placeholder="Username"
            v-model="user.userName"
          >
          </base-input>
        </div>
        <div class="center">
          <base-input
            label="Password"
            v-model="user.password"
            placeholder="Password"
            type="password"
          >
          </base-input>
        </div>
        <base-button nativeType="submit" class="btn-block" fill
          >Login</base-button
        >
      </form>
    </div>
  </div>
</template>

<script>
import {Login} from '@/helpers.js'

export default {
  components: {},
  data() {
    return {
      user: {
        userName: "",
        password: "",
      },
      token: "",
    };
  },
  methods: {
    Login
  }
};
</script>
<style>
</style>
